<template>
    <div class="text-field-with-percentage">
        <label :for="name" v-bind:style="{fontWeight: fontWeight }">{{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div class="input-group mb-3">
            <input ref="text-field-input" type="text" v-model="displayValue" v-on:blur="focusOut" v-on:focus="saveCurrentValue" v-on:input="inputValidateValue" v-on:change="validateValue" :readonly="disabled" v-bind:class="{'disabled-field': disabled, 'not-entered-input': interestRateNotEntered}" class="form-control text-field-input" :id="name" :placeholder="placeholder" :aria-label="placeholder" aria-describedby="basic-addon1">
            <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1">%</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "text-field-with-percentage",
        data () {
            return {
                activeTooltip: false,
                currentValue: '',
                activeInput: false
            }
        },
        props: {
            name: String,
            value: Number,
            placeholder: String,
            label: String,
            isBoldFont: Boolean,
            hasTooltip: Boolean,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            labelPartOne: function () {
                var labelArray = this.label.split(" ");

                if (labelArray.length >= 3 && labelArray[labelArray.length - 1].length <= 3) {
                    labelArray.pop();
                    labelArray.pop();
                    return labelArray.join(" ");
                }

                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                var labelArray = this.label.split(" ");

                if (labelArray.length >= 3 && labelArray[labelArray.length - 1].length <= 3) {
                    var lastWord = labelArray.pop();
                    return labelArray.pop() + " " + lastWord;
                }

                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            displayValue: {
                get: function () {
                    if (this.activeInput && this.label === 'Interest Rate'
                        && this.$store.state.incomeAndExpenses.getInterestRate() === 0) {
                        return '';
                    }

                    return this.value;
                },
                set: function (newValue) {
                    this.value = newValue;
                }
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            tooltipText: function () {
                var helpText = "";

                switch (this.name) {
                    case 'Management-Fee':
                        helpText = "The fee a property manager will charge for the management of " +
                            "the property and tenant. It is a % of the rental income. An average fee of " +
                            "7% + GST has been adopted as a default value";
                        break;
                    case 'Interest-Rate':
                        helpText = "The interest rate being charge by the bank for any borrowed funds " +
                            "(i.e. interest on the new loan amount + the purchase costs if 'Equity' is " +
                            "selected in Step 1)";
                        break;
                    case 'Capital-Growth':
                        helpText = "Enter a chosen average capital growth figure and see what the " +
                            "compounding effect of this growth is over a 10-year period. " +
                            "An average capital growth rate of 7% has been adopted as a default value";
                        break;
                }

                return helpText;
            },
            interestRateNotEntered: function () {
                if (this.label === 'Interest Rate') {
                    return !this.$store.state.interestRateEntered;
                }

                return false;
            }
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            saveCurrentValue: function () {
                if (this.label === 'Interest Rate') {
                    this.$store.commit('interestRateEntered', true);
                }

                this.$nextTick(() => {
                    this.currentValue = this.value;
                    if (this.value === 0) {
                        this.value = '';
                    }
                });

                var valueLength = this.value.toString().length;
                var textFieldInput = this.$refs['text-field-input'];
                setTimeout(function() {
                    textFieldInput.setSelectionRange(valueLength, valueLength);
                }, 0);

                this.activeInput = true;
            },
            focusOut: function () {

                if (this.value === '') {
                    this.value = 0;
                }

                this.activeInput = false;
            },
            validateValue: function () {

               if (this.value >= 0 && this.value <= 100.00 && !isNaN(this.value)) {
                    if (Math.floor(this.value) !== Number(this.value)) {
                        if (this.value.toString().split(".")[1].length > 2) {
                            this.value = Number(Math.round(Number(this.value+'e'+2))+'e-'+2);
                        }
                    }
                    this.currentValue = this.value;
                    this.$emit('calc', Number(this.value));
                } else {
                    this.value = this.currentValue;
                }
            },
            inputValidateValue: function () {

                if (this.name === 'Interest-Rate') {
                    if (this.value >= 0 && this.value <= 100.00 && !isNaN(this.value) && this.value.slice(-1) !== '.') {
                        if (Math.floor(this.value) !== Number(this.value)) {
                            if (this.value.toString().split(".")[1].length <= 2) {
                                this.currentValue = this.value;
                                this.$emit('calc', this.value);
                            }
                        } else {
                            this.currentValue = this.value;
                            this.$emit('calc', this.value);
                        }
                    }
                }
            }
        },
        mounted() {

            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            })
        }
    }
</script>

<style scoped>

    label {
        float: left;
        width: 48% !important;
        font-size: 20px;
        color: #465978;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .property-management-textfield .calc-tooltip {
        width: 260px;
        height: 122px;
        top: -123px;
        margin-left: -475%;
    }

    .property-management-textfield .arrow-down {
        margin-left: 88px;
    }

    .capital-growth .input-group {
        margin-top: 0;
    }

    .input-group {
        width: 50%;
        max-width: 110px;
        margin-left: auto;
        font-size: 20px;
        margin-top: 0;
        align-self: start
    }

    .input-group-text {
        font-weight: bold;
        background-color: #fff;
        color: #465978;
        font-size: 18px;
        height: 38px;
    }

    .text-field-with-percentage {
        width: 85%;
        margin: 0 auto;
        font-size: 20px;
        display: flex;
    }

    .text-field-input {
        background-color: #fff;
        text-align: right;
        font-size: 20px;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .not-entered-input {
        background-color: #ffcccc;
        border-width: 2px;
        border-color: #d9534f;
    }

    .interest-rate .calc-tooltip {
        width: 238px;
        height: 122px;
        top: -123px;
        margin-left: -475%;
    }

    .interest-rate .arrow-down {
        margin-left: 88px;
    }

    .capital-growth .calc-tooltip {
        width: 260px;
        height: 138px;
        top: -140px;
        margin-left: -475%;
    }

    .capital-growth .arrow-down {
        margin-left: 88px;
    }

    .capital-growth label {
        width: 70% !important;
    }

    .capital-growth .input-group {
        margin-bottom: 30px !important;
    }

    .disabled-field {
        cursor: pointer;
        background-color: #e9ecef;
    }

    @media (min-width: 1287px) {
        .insurance .calc-tooltip {
            margin-left: -115%;
        }

        .insurance .arrow-down {
            margin-left: 15px;
        }
    }

    @media (min-width: 1063px) and (max-width: 1262px) {
        .other-expenses .calc-tooltip {
            margin-left: -115%;
        }

        .other-expenses .arrow-down {
            margin-left: 15px;
        }
    }

    @media (min-width: 768px) {
        .property-management-textfield .calc-tooltip {
            margin-left: -175%;
        }

        .property-management-textfield .arrow-down {
            margin-left: 27px;
        }
    }

    @media (min-width: 768px) and (max-width: 1030px) {
        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }

        .stamp-duty .calc-tooltip {
            margin-left: -75%;
        }

        .stamp-duty .arrow-down {
            margin-left: 7px;
        }

        .pre-purchase-costs .calc-tooltip {
            margin-left: -280%;
        }

        .pre-purchase-costs .arrow-down {
            margin-left: 49px;
        }

        .other-costs .calc-tooltip {
            margin-left: -330%;
        }

        .other-costs .arrow-down {
            margin-left: 57px;
        }
    }

    @media (min-width: 768px) and (max-width: 960px) {
        .insurance .calc-tooltip {
            margin-left: -75%;
        }

        .insurance .arrow-down {
            margin-left: 7px;
        }

        .property-management-textfield .calc-tooltip {
            margin-left: -175%;
        }

        .property-management-textfield .arrow-down {
            margin-left: 27px;
        }
    }

    @media (min-width: 768px) and (max-width: 947px) {

        .loan-amount .calc-tooltip {
            margin-left: -375%;
        }

        .loan-amount .arrow-down {
            margin-left: 67px;
        }

    }

    @media (min-width: 768px) and (max-width: 845px) {
        .property-management-textfield label {
            font-size: 19px;
        }

        .other-expenses .calc-tooltip {
            margin-left: -75%;
        }

        .other-expenses .arrow-down {
            margin-left: 7px;
        }
    }

    @media (max-width: 780px) {
        .calc-tooltip {
            margin-left: -145%;
        }

        .arrow-down {
            margin-left: 21px;
        }
    }

    @media (min-width: 1024px) {
        .text-field-with-percentage {
            margin-bottom: 12px;
        }

        .capital-growth {
            margin-bottom: 0;
        }
    }

    @media (max-width: 484px) {
        .capital-growth .calc-tooltip {
            margin-left: -145%;
        }

        .capital-growth .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 435px) {
        .input-group {
            width: 50%;
        }
    }

    @media (min-width: 370px) and (max-width: 544px) {
        .property-management-textfield label {
            width: 181px !important;
        }
    }

    @media (max-width: 420px) {
        .other-expenses .calc-tooltip, .loan-amount .calc-tooltip {
            margin-left: -75%;
        }

        .other-expenses .arrow-down, .loan-amount .arrow-down {
            margin-left: 7px;
        }
    }

    @media (max-width: 388px) {
        .capital-growth .calc-tooltip {
            margin-left: -475%;
        }

        .capital-growth .arrow-down {
            margin-left: 88px;
        }
    }

    @media (max-width: 365px) {
        .other-expenses .calc-tooltip, .insurance .calc-tooltip{
            margin-left: -275%;
        }

        .other-expenses .arrow-down, .insurance .arrow-down {
            margin-left: 47px;
        }
    }

    @media (min-width: 361px) and (max-width: 373px) {
        .stamp-duty .calc-tooltip {
            margin-left: -330%;
        }

        .stamp-duty .arrow-down {
            margin-left: 58px;
        }
    }

    @media (max-width: 364px) {
        .capital-growth .calc-tooltip {
            margin-left: -45%;
        }

        .capital-growth .arrow-down {
            margin-left: 2px;
        }
    }

    @media (min-width: 364px) and (max-width: 388px) {
        .capital-growth .calc-tooltip {
            margin-left: -475%;
        }

        .capital-growth .arrow-down {
            margin-left: 88px;
        }
    }

    @media (max-width: 361px) {
        .stamp-duty .calc-tooltip {
            margin-left: -75%;
        }

        .stamp-duty .arrow-down {
            margin-left: 7px;
        }
    }

    @media (max-width: 341px) {
        .insurance .calc-tooltip {
            margin-left: -75%;
        }

        .insurance .arrow-down {
            margin-left: 7px;
        }

        .individual-income .calc-tooltip {
            margin-left: -75%;
        }

        .individual-income .arrow-down {
            margin-left: 7px;
        }
    }

    @media (max-width: 336px) {
        .loan-amount .calc-tooltip {
            margin-left: -255%;
        }

        .loan-amount .arrow-down {
            margin-left: 43px;
        }
    }

    @media (max-width: 329px) {

        .pre-purchase-costs .calc-tooltip {
            margin-left: -280%;
        }

        .pre-purchase-costs .arrow-down {
            margin-left: 49px;
        }

        .other-costs .calc-tooltip {
            margin-left: -330%;
        }

        .other-costs .arrow-down {
            margin-left: 57px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/TextFieldWithPercentage.vue